import { type StyleConfigProps, type VisibilityElementProps } from '@blaze-runtime/engine-domain';
import { type ColumnInfo } from '@blaze-shared/api-contracts-domain';
import {
  type BorderRadiusValue,
  type CanvasElementPropertiesWithData,
  type ElementLabelPropsWithPositionAndWidth,
  type FontOptions,
  type LabelIconAlignment,
  type PropertiesConfigInputColorModel,
  type PropertiesConfigInputFontStyleOptions,
  type PropertiesConfigInputSpacingAndAlignmentModel,
} from '@blaze-shared/elements-domain';
import { type ValueWithUnitOfMeasure } from '@blaze-shared/shared-util';

export const DEFAULT_RECORD_AUDIO_FILE_COLUMNS: ColumnInfo[] = [
  {
    name: 'content',
    columnType: 'String',
    dataType: 'String',
    isProfilePicture: false,
  },
  {
    name: 'filename',
    columnType: 'String',
    dataType: 'String',
    isProfilePicture: false,
  },
  {
    name: 'mimetype',
    columnType: 'String',
    dataType: 'String',
    isProfilePicture: false,
  },
  {
    name: 'size',
    columnType: 'Number',
    dataType: 'Number',
    isRequired: false,
    isProfilePicture: false,
  },
];

export interface AudioRecorderOutput {
  content: string;
  filename: string;
  mimetype: string;
  size?: number | null;
}

type PropsModel = CanvasElementPropertiesWithData & StyleConfigProps & VisibilityElementProps;

export type AudioRecorderStyleMode = 'idle' | 'recording';

export type AudioRecorderPropsModel = PropsModel & {
  content: {
    button: {
      icon?: string;
      iconStop?: string;
      label: string;
      labelStop: string;
    };
    title: ElementLabelPropsWithPositionAndWidth;
    options: {
      recordMode: 'click' | 'hold';
    };
  };
  style: {
    general: {
      title: PropertiesConfigInputColorModel;
      offset: PropertiesConfigInputSpacingAndAlignmentModel;
    };

    label: {
      // common
      font: FontOptions;
      mode: AudioRecorderStyleMode;
      // idle
      idle: {
        fontWeight: string;
        textStyle: PropertiesConfigInputFontStyleOptions;
        color: PropertiesConfigInputColorModel;
      };
      // recording
      recording: {
        fontWeight: string;
        textStyle: PropertiesConfigInputFontStyleOptions;
        color: PropertiesConfigInputColorModel;
      };
    };

    button: {
      iconPosition?: LabelIconAlignment;
      iconSize?: ValueWithUnitOfMeasure;
      mode: AudioRecorderStyleMode;
      idle: {
        fill: PropertiesConfigInputColorModel;
        iconColor: PropertiesConfigInputColorModel;
      };
      recording: {
        fill: PropertiesConfigInputColorModel;
        iconColor: PropertiesConfigInputColorModel;
      };
    };

    background: {
      mode: AudioRecorderStyleMode;
      idle: {
        fill: PropertiesConfigInputColorModel;
        outline: PropertiesConfigInputColorModel;
        outlineRadius: BorderRadiusValue;
        outlineWidth: ValueWithUnitOfMeasure;
      };
      recording: {
        fill: PropertiesConfigInputColorModel;
        outline: PropertiesConfigInputColorModel;
        outlineRadius: BorderRadiusValue;
        outlineWidth: ValueWithUnitOfMeasure;
      };
    };
  };
};
